import { getCookie } from './cookies'
import { getCookieSettingsOptions } from './options'

export const COOKIE_SETTINGS_NAME = 'ta-cookie-settings'

export default function getCookieSettings() {
  const options = getCookieSettingsOptions()
  const ids = options.settings.map((el) => el.id).filter((el) => !!el)
  let cookieSettings: { [key: string]: boolean }
  try {
    cookieSettings = JSON.parse(getCookie(COOKIE_SETTINGS_NAME) || '')
  } catch (e) {
    cookieSettings = {}
  }

  ids.forEach((id) => {
    if (!(id in cookieSettings)) {
      cookieSettings[id] = true
    }
  })

  return cookieSettings
}
